import React, { useState, useEffect, useContext } from 'react';
import { GetAllStationSummary, GetPlanAudienceTotals } from '../../../../services/CampaignsDataService';
import DeliveryTableTable from './DeliveryTableTable';
import { AirtimePlanningContext } from '../../../../contexts/AirtimePlanningContext';

const DeliveryTablePage3 = ({
    tableColumnDefinitions,
    selectedPlanId,
    setSelectedStationId,
    setModalShowing,
    showImpacts,
    showBaseImpacts,
}) => {
    const {
        currentCampaignVersionId,
    } = useContext(AirtimePlanningContext);

    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [audienceTotals, setAudienceTotals] = useState({});

    useEffect(() => {
        GetPlanAudienceTotals(selectedPlanId).then((res) => {
            setAudienceTotals(res)
        })
    }, []);

    const gridContainer = {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: '30px 57px 50px 0.5fr 84px 70px',
        gridGap: 0,
        paddingTop: 24,
        width: '100%',
        height: '650px',
        color: '#414141'
    };

    const gridItem = {
        textAlign: 'center',
        padding: 0
    };

    const titleArea = {
        gridColumn: '1 / 4',
        paddingLeft: 350,
        fontSize: 22,
        fontWeight: 500
    };

    const tableArea = {
        gridColumn: '1 / 4'
    };

    const getAllStationPlanSummary = (planId,impactOption) => {
        if (planId) {
            GetAllStationSummary(planId,impactOption, currentCampaignVersionId)
                .then((result) => {
                    result.sort((a,b)=>a.stationName.toLowerCase() > b.stationName.toLowerCase() ? 1 :-1);
                    setData(result);
                })
                .catch((error) => {
                    setData([]);
                    setSelectedRow({});
                    console.log(error);
                });
        }
    };
    useEffect(() => {
        if (selectedPlanId) {
            getAllStationPlanSummary(selectedPlanId,showBaseImpacts);
        }
    }, []);

    return (
        <div style={gridContainer}>
            <div style={titleArea}>
                <span>Campaign Planning Summary - Overall Delivery</span>
            </div>

            <div style={gridItem} />
            <div style={gridItem} />
            <div style={gridItem} />
            <div style={{ ...gridItem, ...tableArea }}>
                <DeliveryTableTable
                    columnDefinitions={tableColumnDefinitions}
                    data={data}
                    selectedRow={selectedRow}
                    onSetSelectedRow={setSelectedRow}
                    setSelectedStationId={setSelectedStationId}
                    setModalShowing={setModalShowing}
                    audienceTotals={audienceTotals}
                />
            </div>

        </div>
    );
};

export default DeliveryTablePage3;
